import React, { useEffect,useState } from "react";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import axios from "axios";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";
import Datatables from "component/booking/Datatables";
import DetailBooking from "component/booking/DetailBooking";

function Accepted() {
  const [activeContent, setActiveContent] = useState("booking");
  const [selectedAccepted, setSelectedAccepted] = useState(null);
  const [accepted, setAccepted] = useState([]);

  const fetchAccepted = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${process.env.REACT_APP_API}/show-booking`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ status: "ACCEPTED" })
      });
  
      if (!response.ok) throw new Error("Gagal mengambil data booking accepted");
  
      const data = await response.json();
      setAccepted(Array.isArray(data.data) ? data.data : []);
    } catch (error) {
      console.error("Error fetching accepted:", error);
    }
  };

  useEffect(() => {
      document.title = "Green Hill Kemuning | Booking Accepted";
      window.scrollTo(0, 0);
      fetchAccepted();
  }, []);


  const handleDetailBooking = (DetailBooking) => {
    setActiveContent("DetailBooking");
    setSelectedAccepted(DetailBooking);
  }

    const handleCanceledBooking = async (invoice, action) => {
      try {
        if (!invoice) {
          alert("Invoice tidak ditemukan");
          return;
        }

        if (action !== "cancel") {
          alert("Aksi tidak valid:", action);
          return;
        }

        const confirmed = await showConfirm({
          title: 'Batalkan Booking',
          text: `Apakah Anda yakin ingin membatalkan booking dengan invoice ${invoice}?`,
          confirmButtonText: 'Ya, Batalkan'
        });

        if (!confirmed) return;

        const payload = {
          invoice,
          status: "CANCELED"
        };

        const response = await axios.put(
          `${process.env.REACT_APP_API}/booking-confirm`,
          payload
        );

        if (response.status === 200 || response.status === 201) {
          showSuccess(response.data.message || "Cancel booking berhasil");
          handleBack();
        } else {
          showError(response.data.message || "Gagal Cancel Booking");
        }
      } catch (error) {
        console.error("Error confirm booking:", error);
        showError(error.response?.data?.message || "Terjadi kesalahan saat cancel booking");
      }
    };

    const handleBack = () => {
        fetchAccepted();
        setActiveContent("booking");
    };
      
  return (
    <div class="layout-wrapper layout-content-navbar">
      <div class="layout-container">
        <Sidebar />

        <div class="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
            <Navbar />
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                  <div class="row px-4">
                      <div class="card shadow p-3">
                        <div class="card-body">

                          {activeContent === "booking" && (
                            <div className="row content-item">
                              <div className="d-flex justify-content-between align-items-center">
                                <h5 className="card-title mb-3">Accepted Booking</h5>
                              </div>
                              <Datatables
                                data={accepted}
                                onDetailBooking={handleDetailBooking}
                                responsive
                                dense
                              />
                            </div>
                          )}

                          {activeContent === "DetailBooking" && (
                            <div className="row content-item">
                              <DetailBooking
                                booking={selectedAccepted}
                                onBack={handleBack}
                                onStatusBooking={handleCanceledBooking}
                              />
                            </div>
                          )}

                        </div>  
                      </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div class="layout-overlay layout-menu-toggle"></div>
 
    </div>
  );
}

export default Accepted;
